import React, { useState } from "react";
import { FaMicroscope, FaAward, FaTruckLoading } from "react-icons/fa";
import "./WhyChooseUs.css";

const data = [
  {
    title: "PUMP TESTING",
    code: "ISO_9906_COMPLIANT",
    icon: <FaMicroscope />,
    desc:
      "Test facilities are constructed in accordance with ISO 9906, and can test centrifugal pumps up to a flow-rate of 300 l/sec. Larger pump sets can be run using a 350kVa generator set. Gantry crane and forklift facilities with space for many different pumpset configurations. All test equipment is tested and calibrated to international standards controlled by our ISO 9001:2015 system.",
    stats: [
      { label: "FLOW", value: "300", unit: "L/S" },
      { label: "POWER", value: "350", unit: "KVA" },
      { label: "ISO", value: "9001:2015" }
    ]
  },
  {
    title: "QUALITY",
    code: "ZERO_DEFECT_GOAL",
    icon: <FaAward />,
    desc:"We are strictly adhere towards our quality system and certified by ISO 9001: 2015. The Quality assurance system will follow approved Quality plan while manufacturing the product. All instrumentation and measuring instruments are calibrated time to time. The facilities available are at its best for the range of the product.The company has a belief is excellence and is dedicated to proving outstanding quality in its range of products and services. We endeavor to be responsive to the needs of our clients and to encourage innovation in new ideas and improve products, embracing the latest technology in our design and production facilities.",
    stats: [
      { label: "CHECK", value: "100%" },
      { label: "AUDIT", value: "MONTHLY" },
      { label: "CERT", value: "ISO" }
    ]
  },
  {
    title: "SERVICES",
    code: "GLOBAL_24_7_OPS",
    icon: <FaTruckLoading />,
    desc:
      "FLOWTECH PUMPS AND MOTORS is well represented by its own service team. We have experienced staff and offer excellent service coverage. As a FLOWTECH PUMPS AND MOTORS customer, you can enjoy fast and reliable service wherever you are located, whether in unexpected emergencies or as part of a maintenance contract.",
    stats: [
      { label: "RESPONSE", value: "FAST" },
      { label: "TEAM", value: "EXPERT" },
      { label: "SUPPORT", value: "24/7" }
    ]
  }
];


const WhyChooseUs = () => {
  const [active, setActive] = useState(0);
  const current = data[active];

  return (
    <section className="hud">
      <div className="hud-bg" />

      <div className="hud-wrap">

        {/* LEFT MENU */}
        <aside className="hud-menu">
          <span className="hud-small">SELECT CAPABILITY</span>
          <h2>CORE SYSTEMS</h2>

          {data.map((item, i) => (
            <div
              key={i}
              className={`hud-item ${active === i ? "active" : ""}`}
              onClick={() => setActive(i)}
            >
              <span className="hud-index">0{i + 1}</span>
              <span>{item.title}</span>
            </div>
          ))}
        </aside>

        {/* RIGHT PANEL */}
        <div className="hud-panel">
          <div className="hud-panel-header">
            <div className="hud-icon">{current.icon}</div>
            <div>
              <span className="hud-code">{current.code}</span>
              <h3>{current.title}</h3>
            </div>
          </div>

          <p className="hud-desc">{current.desc}</p>

          <div className="hud-stats">
            {current.stats.map((s, i) => (
              <div key={i} className="hud-stat">
                <span className="hud-stat-label">{s.label}</span>
                <span className="hud-stat-value">
                  {s.value}
                  {s.unit && <small>{s.unit}</small>}
                </span>
                <div className="hud-line" />
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default WhyChooseUs;
